<template>
  <div class="auth-page container py-5">
    <div class="row justify-content-center">
      <div class="col-md-6 col-lg-5">
        <div class="card auth-card">
          <h2>{{ t.title }}</h2>
          <p class="muted">{{ t.subtitle }}</p>

          <div v-if="sent" class="success-box">
            <p>{{ t.sentMessage }}</p>
          </div>

          <form v-else @submit.prevent="onSubmit">
            <label class="field">
              <span>{{ t.email }}</span>
              <input type="email" v-model="email" required />
            </label>

            <button type="submit" class="primary" :disabled="busy">
              {{ busy ? t.submitting : t.submit }}
            </button>
          </form>

          <div class="alt">
            <router-link :to="{ name: 'login' }">{{ t.backToLogin }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

const I18N = {
  az: {
    title: "Şifrəni unutmusunuz?",
    subtitle: "Email ünvanınızı daxil edin, şifrə bərpa linki göndərək.",
    email: "Email",
    submit: "Linki göndər",
    submitting: "Göndərilir…",
    sentMessage: "Əgər bu email qeydiyyatdadırsa, şifrə bərpa linki göndərildi. Poçt qutunuzu (və spam qovluğunu) yoxlayın.",
    backToLogin: "← Daxil olma səhifəsi",
  },
  de: {
    title: "Passwort vergessen?",
    subtitle: "Geben Sie Ihre E-Mail ein. Wir senden Ihnen einen Link zum Zurücksetzen.",
    email: "E-Mail",
    submit: "Link senden",
    submitting: "Wird gesendet…",
    sentMessage: "Falls diese E-Mail registriert ist, wurde ein Link zum Zurücksetzen gesendet. Bitte prüfen Sie Ihren Posteingang (auch den Spam-Ordner).",
    backToLogin: "← Zurück zur Anmeldung",
  },
  en: {
    title: "Forgot password?",
    subtitle: "Enter your email and we'll send a password reset link.",
    email: "Email",
    submit: "Send link",
    submitting: "Sending…",
    sentMessage: "If this email is registered, a reset link has been sent. Please check your inbox (and spam folder).",
    backToLogin: "← Back to sign in",
  },
  ru: {
    title: "Забыли пароль?",
    subtitle: "Введите email, и мы отправим ссылку для сброса пароля.",
    email: "Email",
    submit: "Отправить ссылку",
    submitting: "Отправка…",
    sentMessage: "Если этот email зарегистрирован, ссылка для сброса отправлена. Проверьте входящие (и папку Спам).",
    backToLogin: "← Назад к входу",
  },
  tr: {
    title: "Şifremi unuttum?",
    subtitle: "E-posta adresinizi girin, sıfırlama bağlantısı gönderelim.",
    email: "E-posta",
    submit: "Bağlantıyı gönder",
    submitting: "Gönderiliyor…",
    sentMessage: "Bu e-posta kayıtlıysa sıfırlama bağlantısı gönderildi. Gelen kutunuzu (ve spam klasörünü) kontrol edin.",
    backToLogin: "← Girişe dön",
  },
};

export default {
  name: "ForgotPasswordPage",
  data() {
    return { email: "", busy: false, sent: false };
  },
  computed: {
    t() { return I18N[this.$store.state.lang] || I18N.az; },
  },
  methods: {
    async onSubmit() {
      this.busy = true;
      try {
        await axios.post(`/identity/forgot-password`, { email: this.email });
        this.sent = true;
      } catch (e) {
        // toast shown by interceptor
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-page { min-height: 60vh; }
.auth-card {
  background: #fff; border-radius: 12px; padding: 2rem; box-shadow: 0 2px 14px rgba(0,0,0,0.06);
  h2 { color: #1e3c72; margin-bottom: 0.25rem; }
  .muted { color: #64748b; margin-bottom: 1.5rem; font-size: 0.9rem; }
  .field { display: flex; flex-direction: column; gap: 0.3rem; margin-bottom: 1rem;
    span { font-size: 0.78rem; color: #475569; font-weight: 600; }
    input { padding: 0.6rem 0.8rem; border: 1px solid #d0d5dd; border-radius: 6px; font: inherit; outline: none;
      &:focus { border-color: #2a5298; }
    }
  }
  button.primary { width: 100%; padding: 0.7rem; background: #2a5298; color: #fff; border: 0; border-radius: 6px; cursor: pointer; font: inherit; font-weight: 600;
    &:hover:not(:disabled) { background: #1e3c72; }
    &:disabled { opacity: 0.6; cursor: not-allowed; }
  }
  .success-box { background: #e6f6ed; color: #1e7d44; padding: 1rem; border-radius: 8px; border: 1px solid #b6e5c8; font-size: 0.9rem; line-height: 1.5; }
  .alt { margin-top: 1.25rem; padding-top: 1rem; border-top: 1px solid #eef0f4; text-align: center; font-size: 0.85rem;
    a { color: #2a5298; text-decoration: none; &:hover { text-decoration: underline; } }
  }
}
</style>
